export { default as plantLifePNG } from '~/assets/images/plant-life.png'
export { default as plantLifeWEBP } from '~/assets/images/plant-life.webp'
export { default as redCross } from '~/assets/images/red-cross.png'
export { default as greenAccept } from '~/assets/images/green-accept.png'
export { default as animalWorldPNG } from '~/assets/images/animal-world.png'
export { default as animalWorldWEBP } from '~/assets/images/animal-world.webp'
export { default as humanBodyPNG } from '~/assets/images/human-body.png'
export { default as humanBodyWEBP } from '~/assets/images/human-body.webp'
export { default as skinPNG } from '~/assets/images/quiz-skin.png'
export { default as skinWEBP } from '~/assets/images/quiz-skin.webp'
export { default as octopusPNG } from '~/assets/images/quiz-octopus.png'
export { default as octopusWEBP } from '~/assets/images/quiz-octopus.webp'
export { default as frogPNG } from '~/assets/images/quiz-frog.png'
export { default as frogWEBP } from '~/assets/images/quiz-frog.webp'

export const QUESTION = 'Have you learned biology before?'
export const PLANT_LIFE_QUESTION = 'Want to learn about plant life'
export const ANIMAL_WORLD_QUESTION = 'Want to learn about animal life'
export const HUMAN_BODY_QUESTION = 'Want to learn about human body?'
export const LEARN_BIOLOGY_QUESTION = 'Have you learned biology before?'
export const BIOLOGY_LEVEL_QUESTION = 'Satisfied with what you know in biology?'
export const BIOLOGY_LEARNING_COMPLEXITY_QUESTION =
  'Does biology feel hard to learn?'
export const BIOLOGY_SKIN_QUESTION =
  'Did you know your skin fully regenerates every month?'
export const BIOLOGY_OCTOPUS_QUESTION =
  'Did you know your skin fully regenerates every month?'
export const BIOLOGY_FROG_QUESTION =
  'Did you know some frogs freeze and come back to life?'
export const MOTIVATED_WHILE_LEARNING_QUESTION =
  'Is it easy for you to stay motivated while learning?'
export const RECOMMENDATION_QUESTION =
  'Did a friend or mentor recommend MyGrowth to you?'

export const ANSWERS = {
  yes: 'yes',
  no: 'no',
}
